import React, { useContext } from 'react';
import { Tabs } from 'antd';
import styles from './PatientForm.module.scss';
import { mainContext } from '../../context/context';
import PatientForm from '../../components/InformationsForms/PatientForm';
import EmployerForm from '../../components/InformationsForms/EmployerForm';
import ReferredByForm from '../../components/InformationsForms/ReferredByForm';
import ProceduresForm from '../../components/InformationsForms/ProceduresForm';
import SpecialInstructions from '../../components/InformationsForms/SpecialInstructions';
import { pageWrapper } from '../../utils/helpers';

const { TabPane } = Tabs;

export default function InformationFormLayout() {
    const { currentTab, activeTab } = useContext(mainContext);

    const handleChange = (newValue) => {
        currentTab(newValue);
    };

    const renderPatientForm = () => {
    const renderElement = () => {
        return <PatientForm />
    }
    return (
        <>{pageWrapper(renderElement, "")}</>
    )
}

const renderEmployerForm = () => {
    const renderElement = () => {
        return <EmployerForm />
    }
    return (
        <>{pageWrapper(renderElement, "")}</>
    )
}

const renderReferredByForm = () => {
    const renderElement = () => {
        return <ReferredByForm />
    }
    return (
        <>{pageWrapper(renderElement, "")}</>
    )
}

const renderProceduresForm = () => {
    const renderElement = () => {
        return <ProceduresForm />
    }
    return (
        <>{pageWrapper(renderElement, "")}</>
    )
}

const renderSpecialInstructions = () => {
    const renderElement = () => {
        return <SpecialInstructions />
    }
    return (
        <>{pageWrapper(renderElement, "")}</>
    )
}

    return (
        <Tabs
            activeKey={String(activeTab)}
            onChange={handleChange}
            centered
            tabBarStyle={{ margin: '0 auto', fontWeight: '600', fontSize: '26px', width: '100%' }}
        >
            <TabPane className={styles.tabs} tab="Patient Information" key="0" disabled={activeTab !== 0}>
                {activeTab == 0 && renderPatientForm()}
            </TabPane>
            <TabPane className={styles.tabs} tab="Employer Information" key="1" disabled={activeTab !== 1}>
                {activeTab == 1 && renderEmployerForm()}
            </TabPane>
            <TabPane className={styles.tabs} tab="Referred By" key="2" disabled={activeTab !== 2}>
                {activeTab == 2 && renderReferredByForm()}
            </TabPane>
            <TabPane className={styles.tabs} tab="Procedures" key="3" disabled={activeTab !== 3}>
                {activeTab == 3 && renderProceduresForm()}
            </TabPane>
            <TabPane className={styles.tabs} tab="Special Instructions" key="4" disabled={activeTab !== 4}>
                {activeTab == 4 && renderSpecialInstructions()}
            </TabPane>
        </Tabs>
    );
}

